export async function createAssetDataset(id, profile = {}) {
    // add new assetprofile to entity
    const assetProfileModel = {
        ...{
            name: '',
            tagline: '',
            description: '',
            yearBuilt: 0,
            buildingClass: '',
            zoningDistrict: '',
            latitude: 0,
            longitude: 0,
            elevation: 0,
            addressLine1: '',
            addressLine2: '',
            city: '',
            county: '',
            state: '',
            postalCode: '',
            country: '',
            imageAsOfDate: null,
            url: '',
            link: [],
            modelAsOfDate: null,
            modelFile: '',
            entityId: id,
        },
        ...profile,
    };

    const assetProfileModelData = await this.axios.post(
        `/assetprofiles`,
        assetProfileModel
    );

    // add new assetdesign to entity
    const assetDesignModel = {
        asOfDate: null,
        aboveGradeHeight: 0,
        aboveGradeFloors: 0,
        belowGradeDepth: 0,
        belowGradeFloors: 0,
        floorArea: 0,
        parcelArea: 0,
        floorToAreaRatio: 0,
        footprintArea: 0,
        usableArea: 0,
        rentableArea: 0,
        rentableUsableFactor: 0,
        unitCount: 0,
        unitFloorArea: 0,
        pctOfAssetFloorArea: 0,
        entityId: id,
    };
    const assetDesignModelData = await this.axios.post(
        `/assetdesigns`,
        assetDesignModel
    );

    // add new assetschedule to entity
    const assetScheduleModel = {
        constructionPhaseAsOfDate: null,
        constructionPhaseProjectedStart: null,
        constructionPhaseProjectedEnd: null,
        constructionPhaseActualStart: null,
        constructionPhaseActualEnd: null,
        constructionPhaseProjectedCompletionPct: 0,
        constructionPhaseActualCompletionPct: 0,
        designPhaseAsOfDate: null,
        designPhaseProjectedStart: null,
        designPhaseProjectedEnd: null,
        designPhaseActualStart: null,
        designPhaseActualEnd: null,
        designPhaseProjectedCompletionPct: 0,
        designPhaseActualCompletionPct: 0,
        overallAsOfDate: null,
        overallProjectedCompletionPct: 0,
        overallActualCompletionPct: 0,
        planningPhaseAsOfDate: null,
        planningPhaseProjectedStart: null,
        planningPhaseprojectedEnd: null,
        planningPhaseActualStart: null,
        planningPhaseActualEnd: null,
        planningPhaseProjectedCompletionPct: 0,
        planningPhaseActualCompletionPct: 0,
        stabilizationPhaseAsOfDate: null,
        stabilizationPhaseProjectedStart: null,
        stabilizationPhaseProjectedEnd: null,
        stabilizationPhaseActualStart: null,
        stabilizationPhaseActualEnd: null,
        stabilizationPhaseProjectedCompletionPct: 0,
        stabilizationPhaseActualCompletionPct: 0,
        steadyStateAsOfDate: null,
        steadyStateReached: false,
        entityId: id,
    };
    const assetScheduleModelData = await this.axios.post(
        `/assetschedules`,
        assetScheduleModel
    );

    // add new developmentfinancial to entity
    const developmentFinancialModel = {
        developmentActualsAsOfDate: null,
        overallBudget: 0,
        overallContingencyQuantity: 0,
        overallContingencyPct: 0,
        overallSpend: 0,
        landCostBudget: 0,
        landCostContingencyQuantity: 0,
        landCostContingencyPct: 0,
        landCostSpend: 0,
        hardCostBudget: 0,
        hardCostContingencyQuantity: 0,
        hardCostContingencyPct: 0,
        hardCostSpend: 0,
        softCostBudget: 0,
        softCostContingencyQuantity: 0,
        softCostContingencyPct: 0,
        softCostSpend: 0,
        otherCostBudget: 0,
        otherCostContingencyQuantity: 0,
        otherCostContingencyPct: 0,
        otherCostSpend: 0,
        developmentEstimatesAsOfDate: null,
        developmentCosts: 0,
        landCosts: 0,
        hardCosts: 0,
        softCosts: 0,
        otherCosts: 0,
        steadyStateProjectionsAsOfDate: null,
        annualRecurringRevenue: 0,
        annualRecurringExpenses: 0,
        annualNetOperatingIncome: 0,
        entityId: id,
    };
    const developmentFinancialModelData = await this.axios.post(
        `/developmentfinancials`,
        developmentFinancialModel
    );

    // add new assetsustainability to entity
    const assetSustainabilityModel = {
        asOfDate: null,
        districtEnergy: false,
        netZeroAsset: false,
        pedestrian: 0,
        cycling: 0,
        publicTransport: 0,
        automotive: 0,
        annualCarbonProduced: 0,
        annualCarbonSequestered: 0,
        LEEDCertification: '',
        BREEAMCertification: '',
        greenGlobesCertification: '',
        PHIUSPlusCertification: false,
        wiredScoreCertification: '',
        energyStarCertification: false,
        energyStarScore: 0,
        walkScore: 0,
        transitScore: 0,
        bikeScore: 0,
        electricityAnnualConsumption: 0,
        electricityAnnualCost: 0,
        annualOnSiteProduction: 0,
        bikeshareStations: 0,
        bicycleParkingSpots: 0,
        naturalGasAnnualConsumption: 0,
        naturalGasAnnualCost: 0,
        annualGreyWaterProduction: 0,
        annualBlackWaterProduction: 0,
        annualGarbageProduction: 0,
        annualRecyclingProduction: 0,
        waterAnnualConsumption: 0,
        waterAnnualCost: 0,
        entityId: id,
    };
    const assetSustainabilityModelData = await this.axios.post(
        `/assetsustainabilities`,
        assetSustainabilityModel
    );
}